module.exports = __webpack_public_path__ + "img/select-region.f644f58d.png";